module.exports = __webpack_public_path__ + "img/Alexander.dbaed7f1.jpg";